export const MAX_FILE_SIZE = 5242880
